import React from 'react';
import { Card, Space } from 'antd';
import { SoundOutlined } from '@ant-design/icons';
import VoiceNoteRecorder from './VoiceNoteRecorder';
import NotesList from './NotesList';

/**
 * Drop-in notes section for any entity page.
 * Usage: <EntityNotes entityType="proposal" entityId={proposalId} />
 */
const EntityNotes = ({ entityType, entityId }) => {
  if (!entityType || !entityId) return null;

  return (
    <Card
      title={
        <Space>
          <SoundOutlined />
          <span>Voice Notes</span>
        </Space>
      }
      style={{ marginBottom: 24 }}
    >
      <div style={{ marginBottom: 16 }}>
        <VoiceNoteRecorder entityType={entityType} entityId={entityId} />
      </div>
      <NotesList entityType={entityType} entityId={entityId} />
    </Card>
  );
};

export default EntityNotes;
